import api from '@/api'
import { IEDate, uGetDateFormat } from '@appbase/util';

const convertAppointmentTypeToServer = function(value: string) {
	switch (value) {
		case 'Single': return 1;
		case 'RecurringMaster': return 2;
		case 'Occurrence' : return 3;
		case 'Exception': return 4;
	}
	return 1;
}

const convertAppointmentTypeToClient = function(value: number) {
	switch (value) {
		case 1: return 'Single';
		case 2: return 'RecurringMaster';
		case 3: return 'Occurrence';
		case 4: return 'Exception';
	}
	return 'Single';
}

const convertRecurrenceToServer = function(value: reserve.CalendarItemRecurrence | null) {	
	if(value == null)
		return null;	

	let CalendarRecurrence = {
		RecurringType: value.ui_recurringType,
		StartDate: value.startDate,
		EndDate: value.ui_endType == '3' ? value.endDate : null,
		Interval: isNaN(Number(value.interval)) ? 1 : Number(value.interval),
		NumberOfOccurrences: value.ui_endType == '2' ? (isNaN(Number(value.numberOfOccurrences)) ? 0 : Number(value.numberOfOccurrences)) : null,
		FirstDayOfWeek: isNaN(Number(value.firstDayOfWeekValue)) ? 1 : Number(value.firstDayOfWeekValue),
		DayOfMonth: isNaN(Number(value.dayOfMonth)) ? 1 : Number(value.dayOfMonth),
		Month: isNaN(Number(value.monthValue)) ? 1 : Number(value.monthValue),
		DaysOfTheWeek_0: value.daysOfTheWeekArray?.indexOf(0) != -1,
		DaysOfTheWeek_1: value.daysOfTheWeekArray?.indexOf(1) != -1,
		DaysOfTheWeek_2: value.daysOfTheWeekArray?.indexOf(2) != -1,
		DaysOfTheWeek_3: value.daysOfTheWeekArray?.indexOf(3) != -1,
		DaysOfTheWeek_4: value.daysOfTheWeekArray?.indexOf(4) != -1,
		DaysOfTheWeek_5: value.daysOfTheWeekArray?.indexOf(5) != -1,
		DaysOfTheWeek_6: value.daysOfTheWeekArray?.indexOf(6) != -1,
		DaysOfTheWeek_7: value.daysOfTheWeekArray?.indexOf(7) != -1,
		DaysOfTheWeek_8: value.daysOfTheWeekArray?.indexOf(8) != -1,
		DaysOfTheWeek_9: value.daysOfTheWeekArray?.indexOf(9) != -1,
	};

	return CalendarRecurrence;
}

const convertEventToServer = function(item: reserve.CalendarItem) {	
    let event: any = {
		ID: isNaN(Number(item.id)) ? 0 : Number(item.id),		
		EwsID: item.db_ewsid,
		MasterID: item.db_masterID,
		AppointmentType: convertAppointmentTypeToServer(item.appointmentType),
		Status: item.status,
        Subject: item.subject,
		Location: item.location,
		ParentFolderID: Number(item.parentId || (item as any).ParentFolderId),
		StartDate: uGetDateFormat('yyyy-MM-DD', IEDate(item.start)) + 'T' + item.starttime,
		EndDate: uGetDateFormat('yyyy-MM-DD', IEDate(item.end)) + 'T' + item.endtime,
		IsAllDayEvent: item.isAllDayEvent,
		IsCancelled: item.isCancelled,
		RecurringString: item.pidLidRecurrencePattern,
		OrganizerName: item.organizer?.name,
		OrganizerAddress: item.organizer?.address,
		Importance: item.importance,
		CalendarEventBody: {
			Body: item.body,
		},
		IsRecurring: item.isRecurring,
		CalendarRecurrence: convertRecurrenceToServer(item.recurrence),
		RequiredAttendeesList: item.requiredAttendees && item.requiredAttendees.length ? item.requiredAttendees.map((x) => { return {Name: x.name, Address: x.address} }) : [],
		OptionalAttendeesList: item.optionalAttendees && item.optionalAttendees.length ? item.optionalAttendees.map((x) => { return {Name: x.name, Address: x.address} }) : [],
		Attachments: item.attachments,
		AttachmentFileCode: item.code,
		ResourceID: isNaN(Number(item.resourceId)) ? null : (Number(item.resourceId) || null),
		IsDeleted: (item as any).IsDeleted || false,
		IsSendMail: item.isSendMail,
		DeletedAttachIDArray: (item as any).deletedAttachIDs,
	};
    return event;
}

const convertEventToClient = function(item: any):reserve.CalendarItem {
	let requiredAttendeesList = item.requiredAttendeesList?.length ? item.requiredAttendeesList : item.rRequiredAttendeesList;
	let optionalAttendeesList = item.optionalAttendeesList?.length ? item.optionalAttendeesList : item.rOptionalAttendeesList;

    let event: reserve.CalendarItem = {
        ...item,
        id: item.id || item.ID,
        db_ewsid: item.ewsid || item.EwsID || item.ewsID,
        appointmentType: convertAppointmentTypeToClient(item.appointmentType || item.AppointmentType),
        status: item.status || item.Status,
		subject: item.subject || item.Subject,
		location: item.location || item.Location,
		parentId: item.parentFolderID || item.ParentFolderID,
		parentFolderId: item.parentFolderID || item.ParentFolderID,
		start: ((item.startDate || item.StartDate) + '').replace('T', ' '),
		end: ((item.endDate || item.EndDate) + '').replace('T', ' '),
		organizer: {
			name: item.organizerName || item.OrganizerName,
			address: item.organizerAddress || item.OrganizerAddress,
		},
		importance: item.importance || item.Importance,
		isAllDayEvent : (item.isAllDayEvent || item.IsAllDayEvent),
        isCancelled : item.isCancelled || item.IsCancelled,
        pidLidRecurrencePattern: item.recurringString || item.RecurringString,
		body: item.calendarEventBody?.body || item.CalendarEventBody?.body || item.calendarREventBody?.body || item.CalendarREventBody?.body,
		requiredAttendees: requiredAttendeesList && requiredAttendeesList.length ? requiredAttendeesList.map((x:any) => { return {name: x.Name || x.name, address: x.Address || x.address} }) : [],
		optionalAttendees: optionalAttendeesList && optionalAttendeesList.length ? optionalAttendeesList.map((x:any) => { return {name: x.Name || x.name, address: x.Address || x.address} }) : [],
        attachments: item.attachments || item.Attachments,
        code: item.attachmentFileCode || item.AttachmentFileCode,
        resourceId: item.resourceID || item.ResourceID,
        db_masterID: item.masterID || item.MasterID,
        db_selectID: item.selectGuid || item.SelectGuid,
        hasAttachments: item.isAttachment || item.IsAttachment,
	} as reserve.CalendarItem;
    return event;
}

export default {
    getDbResources(comCode: string): Promise<reserve.DbResource[]> {
        return api.get<reserve.DbResource[]>({
            url: '/Portal/ReservationDb/api/resources',
			params: {
				comCode: comCode
			}
        });
    },

    createCalendarEvent(item: reserve.CalendarItem) {
		console.log('beforceConvert', item);
		let converted = convertEventToServer(item);
        return api.post<any>({
            url: '/Mail/CalendarEvent/api/create?funcName=createCalendarEvent',
            data: {
				ParentFolderID: converted.ParentFolderID,
				EwsID: converted.EwsID,
				AppointmentType: converted.AppointmentType,
				AttachmentFileCode: converted.AttachmentFileCode,
				PersonCode: converted.PersonCode,
				DeptCode: converted.DeptCode,
				OrganizerName: converted.OrganizerName,
				OrganizerAddress: converted.OrganizerAddress,
				ResourceID: converted.ResourceID,
				Status: converted.Status,
				Subject: converted.Subject,
				Location: converted.Location,
				StartDate: converted.StartDate,
				EndDate: converted.EndDate,
				Importance: converted.Importance,
				IsDeleted: converted.IsDeleted,
				IsAllDayEvent: converted.IsAllDayEvent,
				IsRecurring: converted.IsRecurring,
				IsCancelled: converted.IsCancelled,
				IsSendMail: converted.IsSendMail,
				RecurringString: converted.RecurringString,
				CreatedId: converted.CreatedId,
				UpdatedId: converted.UpdatedId,
				CreatedDate: converted.CreatedDate,
				UpdatedDate: converted.UpdatedDate,
				CalendarEventBody: converted.CalendarEventBody,
				CalendarRecurrence: converted.CalendarRecurrence,
				OptionalAttendeesList: converted.OptionalAttendeesList || [],
				RequiredAttendeesList: converted.RequiredAttendeesList || [],
				CalendarFolder: converted.CalendarFolder,
				CalendarResource: converted.CalendarResource,
				USE_TA_CALENDAR_EVENT_BODY: converted.USE_TA_CALENDAR_EVENT_BODY || true,
				USE_TA_OPTIONAL_ATTENDEES: converted.USE_TA_OPTIONAL_ATTENDEES || true,
				USE_TA_REQUIRED_ATTENDEES: converted.USE_TA_REQUIRED_ATTENDEES || true,
				USE_TA_CALENDAR_RECURRENCE: converted.USE_TA_CALENDAR_RECURRENCE || true,
				USE_TA_CALENDAR_RESOURCE: converted.USE_TA_CALENDAR_RESOURCE || true,
				USE_TA_CALENDAR_FOLDER: converted.USE_TA_CALENDAR_FOLDER || false,				
				USE_TA_CALENDAR_R_EVENT: converted.USE_TA_CALENDAR_R_EVENT || false				
            }
        });
    },

	getCalendarEventList(item: any) {
        return api.post<Array<any>>({
            url: '/Mail/DBCalendar/api/getevents?funcName=getCalendarEventList',
            data: {
                FolderID: item.FolderID,
                StartDate: item.StartDate,
                EndDate: item.EndDate		
            }
        }).then((res) => {
            return res.map((data) => {
                let newItem = convertEventToClient(data);
                let result = {
                    ...newItem                    
                };
                return result;
            });
        });;
    },

	getCalendarEvent(id: number, personCode: string): Promise<reserve.CalendarItem> {
        return api.post<any>({
            url: '/Mail/CalendarEvent/api/get?funcName=getCalendarEvent',
            data: {
				ID: id,
				PersonCode: personCode,
				USE_TA_CALENDAR_EVENT_BODY: true,
				USE_TA_OPTIONAL_ATTENDEES: true,
				USE_TA_REQUIRED_ATTENDEES: true,
				USE_TA_CALENDAR_RECURRENCE: true,
				USE_TA_CALENDAR_RESOURCE: false,
				USE_TA_CALENDAR_FOLDER: false,				
				USE_TA_CALENDAR_R_EVENT: false,
            }
        }).then((res) => {		 
           return convertEventToClient(res);
        });
    },

	getCalendarREvent(id: number, masterId: number, personCode: string): Promise<reserve.CalendarItem> {
		return api.post<any>({
            url: '/Mail/CalendarREvent/api/get?funcName=getRCalendarEvent',
            data: {
				ID: id,
				MasterID: masterId,
				PersonCode: personCode,
				USE_TA_CALENDAR_R_EVENT_BODY: true,
				USE_TA_R_OPTIONAL_ATTENDEES: true,
				USE_TA_R_REQUIRED_ATTENDEES: true,
				USE_TA_CALENDAR_RECURRENCE: false,
				USE_TA_CALENDAR_RESOURCE: false
            }
        }).then((res) => {
		   res = convertEventToClient(res);
           return res;
        });
	},

	searchCalendarEventList(item: reserve.EventSearchRequest) {
        return api.post<Array<any>>({
            url: '/Mail/DBCalendar/api/searchevents?funcName=searchCalendarEventList',
            data: {
                EwsFolderIDArray: null,
                FolderID: null, 
                StartDate: item.startDate, 
                EndDate: item.endDate,
                Keyword: item.keyword || null, 
                Status: null,
                Subject: item.subject || null,
                Location: null, 
                OrganizerName: item.organizerName || null,
                OrganizerAddress: null, 
                PersonCode: null, 
                RequiredAttendees: null, 
                OptionalAttendees: null, 
                EumNoCondition: false, 
                EumPageNumber: 1, 
                EumRowsPerPage: 9999, 
            }
        }).then((res) => {
			return res.map((data) => {
                let newItem = convertEventToClient(data);
                let result = {
                    ...newItem                    
                };
                return result;
            });
        });;
    },

	deleteCalendarEvent(item: any) {
		item = convertEventToServer(item);
        return api.post<any>({
            url: '/Mail/CalendarEvent/api/delete?funcName=deleteCalendarEvent',
            data: {
				ID: item.ID,
				USE_TA_CALENDAR_EVENT_BODY: item.USE_TA_CALENDAR_EVENT_BODY || true,
				USE_TA_OPTIONAL_ATTENDEES: item.USE_TA_OPTIONAL_ATTENDEES || true,
				USE_TA_REQUIRED_ATTENDEES: item.USE_TA_REQUIRED_ATTENDEES || true,
				USE_TA_CALENDAR_RECURRENCE: item.USE_TA_CALENDAR_RECURRENCE || true,
				USE_TA_CALENDAR_FOLDER: item.USE_TA_CALENDAR_FOLDER || false,
				USE_TA_CALENDAR_RESOURCE: item.USE_TA_CALENDAR_RESOURCE || false,
				USE_TA_CALENDAR_R_EVENT: item.USE_TA_CALENDAR_R_EVENT || false,
            }
        });
	},

	updateCalendarEvent(item: any) {
		item = convertEventToServer(item);
        return api.post<any>({
            url: '/Mail/CalendarEvent/api/update?funcName=updateCalendarEvent',
            data: {
				ID: item.ID,
				ParentFolderID: item.ParentFolderID,
				EwsID: item.EwsID,
				AppointmentType: item.AppointmentType,
				AttachmentFileCode: item.AttachmentFileCode,
				PersonCode: item.PersonCode,
				DeptCode: item.DeptCode,
				OrganizerName: item.OrganizerName,
				OrganizerAddress: item.OrganizerAddress,
				ResourceID: item.ResourceID,
				Status: item.Status,
				Subject: item.Subject,
				Location: item.Location,
				StartDate: item.StartDate,
				EndDate: item.EndDate,
				Importance: item.Importance,
				IsDeleted: item.IsDeleted,
				IsAllDayEvent: item.IsAllDayEvent,
				IsRecurring: item.IsRecurring,
				IsCancelled: item.IsCancelled,
				IsSendMail: item.IsSendMail,
				RecurringString: item.RecurringString,
				CreatedId: item.CreatedId,
				UpdatedId: item.UpdatedId,
				CreatedDate: item.CreatedDate,
				UpdatedDate: item.UpdatedDate,
				CalendarEventBody: item.CalendarEventBody,
				CalendarRecurrence: item.CalendarRecurrence,
				OptionalAttendeesList: item.OptionalAttendeesList || [],
				RequiredAttendeesList: item.RequiredAttendeesList || [],
				CalendarFolder: item.CalendarFolder,
				CalendarResource: item.CalendarResource,
				DeletedAttachIDArray: item.DeletedAttachIDArray,
				USE_TA_CALENDAR_EVENT_BODY: item.USE_TA_CALENDAR_EVENT_BODY || true,
				USE_TA_OPTIONAL_ATTENDEES: item.USE_TA_OPTIONAL_ATTENDEES || true,
				USE_TA_REQUIRED_ATTENDEES: item.USE_TA_REQUIRED_ATTENDEES || true,
				USE_TA_CALENDAR_RECURRENCE: item.USE_TA_CALENDAR_RECURRENCE || true,
				USE_TA_CALENDAR_RESOURCE: item.USE_TA_CALENDAR_RESOURCE || true,
				USE_TA_CALENDAR_FOLDER: item.USE_TA_CALENDAR_FOLDER || false,				
				USE_TA_CALENDAR_R_EVENT: item.USE_TA_CALENDAR_R_EVENT || false			
            }
        });
    },

	
	deleteRCalendarEvent(item: any) {
		item = convertEventToServer(item);
        return api.post<any>({
            url: '/Mail/CalendarREvent/api/delete?funcName=deleteCalendarEvent',
            data: {
				ID: item.ID,
				MasterID: item.MasterID,
				USE_TA_CALENDAR_EVENT_BODY: item.USE_TA_CALENDAR_EVENT_BODY || true,
				USE_TA_OPTIONAL_ATTENDEES: item.USE_TA_OPTIONAL_ATTENDEES || true,
				USE_TA_REQUIRED_ATTENDEES: item.USE_TA_REQUIRED_ATTENDEES || true,
				USE_TA_CALENDAR_RECURRENCE: item.USE_TA_CALENDAR_RECURRENCE || true,
				USE_TA_CALENDAR_FOLDER: item.USE_TA_CALENDAR_FOLDER || false,
				USE_TA_CALENDAR_RESOURCE: item.USE_TA_CALENDAR_RESOURCE || false,
				USE_TA_CALENDAR_R_EVENT: item.USE_TA_CALENDAR_R_EVENT || false,
            }
        });
	},

	updateRCalendarEvent(item: any) {
		item = convertEventToServer(item);
        return api.post<any>({
            url: '/Mail/CalendarREvent/api/update?funcName=updateRCalendarEvent',
            data: {
				ID: item.ID,
				MasterID: item.MasterID,
				ParentFolderID: item.ParentFolderID,
				EwsID: item.EwsID,
				AppointmentType: item.AppointmentType,
				AttachmentFileCode: item.AttachmentFileCode,
				PersonCode: item.PersonCode,
				DeptCode: item.DeptCode,
				OrganizerName: item.OrganizerName,
				OrganizerAddress: item.OrganizerAddress,
				ResourceID: item.ResourceID,
				Status: item.Status,
				Subject: item.Subject,
				Location: item.Location,
				StartDate: item.StartDate,
				EndDate: item.EndDate,
				Importance: item.Importance,
				IsDeleted: item.IsDeleted,
				IsAllDayEvent: item.IsAllDayEvent,
				IsRecurring: item.IsRecurring,
				IsCancelled: item.IsCancelled,
				IsSendMail: item.IsSendMail,
				RecurringString: item.RecurringString,
				CreatedId: item.CreatedId,
				UpdatedId: item.UpdatedId,
				CreatedDate: item.CreatedDate,
				UpdatedDate: item.UpdatedDate,
				CalendarREventBody: item.CalendarEventBody,
				CalendarRecurrence: item.CalendarRecurrence,
				ROptionalAttendeesList: item.OptionalAttendeesList || [],
				RRequiredAttendeesList: item.RequiredAttendeesList || [],
				CalendarFolder: item.CalendarFolder,
				CalendarResource: item.CalendarResource,
				DeletedAttachIDArray: item.DeletedAttachIDArray,
				USE_TA_CALENDAR_R_EVENT_BODY: item.USE_TA_CALENDAR_EVENT_BODY || true,
				USE_TA_R_OPTIONAL_ATTENDEES: item.USE_TA_OPTIONAL_ATTENDEES || true,
				USE_TA_R_REQUIRED_ATTENDEES: item.USE_TA_REQUIRED_ATTENDEES || true,
				USE_TA_CALENDAR_RECURRENCE: item.USE_TA_CALENDAR_RECURRENCE || true,
				USE_TA_CALENDAR_RESOURCE: item.USE_TA_CALENDAR_RESOURCE || true,
            }
        });
    },

	getUserReservationList(page: number, perPage: number): Promise<reserve.PagedList<reserve.CalendarItem[]>>{
		return api.get({
			url: `/YEK/Resource/api/getMyReservation?page=${page}&perPage=${perPage}`
		})
	}
}